import axiosClient from '../axiosClient';

export const loginWithEmail = (email, password) =>
  axiosClient.post('/auth/login', { email, password });

export const loginStaff = ({ name, uniqueId, password }) =>
  axiosClient.post('/staff-auth/login', { name, uniqueId, password });

export const loginStaffByEmail = (email, password) =>
  axiosClient.post('/staff-auth/login', { email, password });

export const staffSendOtp = (phone) =>
  axiosClient.post('/staff-auth/send-otp', { phone });

export const staffVerifyOtp = (otpId, otp) =>
  axiosClient.post('/staff-auth/verify-otp', { otpId, otp });

export const sendOtp = (phone) =>
  axiosClient.post('/auth/send-otp', { phone });

export const verifyOtp = (otpId, otp) =>
  axiosClient.post('/auth/verify-otp', { otpId, otp });

export const getProfile = () =>
  axiosClient.get('/auth/profile');

export const getStaffProfile = () =>
  axiosClient.get('/staff-auth/profile');

export const logout = () =>
  axiosClient.post('/auth/logout');
